import {
  Box,
  Button,
  Chip,
  InputLabel,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import useResponsive from "../../hooks/useResponsive";
import { useNavigate } from "react-router-dom";
import ModalContainer from "./modal-container";
import FilterListIcon from "@mui/icons-material/FilterList";
import { CloseDrawerIcon } from "./svg-icons";
import { labelSty } from "./styles-input";
import SelectInput from "./select";
import { getLgaById, getStates, SelectOption } from "../../utils/adhoc-request";
import { InputCustom } from "./input-ui";
import { SearchRepsModal } from "./search-representatives";
import { useNotificationService } from "../../hooks/notification";

const inputSty = {
  border: "none",
  outline: "none",
  height: 40,
  backgroundColor: "transparent",
  width: "100%",
  fontFamily: "Poppins",
  fontSize: 13,

  color: "#000",
  fontWeight: 500,
  "& placeholder": {
    color: "#92A5B5",
  },
};

export interface FilterDataProp {
  state_id: string;
  local_government_id: string;
  search_text: string;
  state: SelectOption[];
  lga: SelectOption[];
  selected_state: string;
  selected_lga: string;
  reps_name: string;
  reps_id: string;
}

const SearchInput = () => {
  const isDesktop = useResponsive("down", "lg", "xl");
  const [text, setText] = useState("");
  const navigate = useNavigate();
  const [open_filter, setOpen_filter] = useState(false);

  const handle_filter = () => setOpen_filter(!open_filter);
  const handle_submit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    navigate(`/search`, {
      state: { search: text, state: "", lga: "", resp: "false" },
    });
  };

  return (
    <>
      <SearchFilters
        open={open_filter}
        handle_modal={handle_filter}
        text={text}
      />
      {!isDesktop && (
        <Box
          sx={{
            width: 350,
            height: 45,
            backgroundColor: "#E7EBEF",
            borderRadius: 30,
            display: "flex",
            gap: "6px",
            paddingX: 2,
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={handle_filter}
        >
          <Stack direction={"row"} alignItems={"center"}>
            <img
              src="/assets/icons/search-icon.svg"
              alt=""
              width={18}
              height={18}
            />
            <Typography variant="body2" sx={{ mx: 2 }}>
              Search Representative
            </Typography>
          </Stack>
          <Button size="small" onClick={handle_filter} sx={{ ml: "auto" }}>
            <FilterListIcon />
          </Button>
        </Box>
      )}
    </>
  );
};

export default SearchInput;

const SearchFilters = ({
  open,
  text,
  handle_modal,
}: {
  open: boolean;
  text: string;
  handle_modal: () => void;
}) => {
  const navigate = useNavigate();
  const { showNotification } = useNotificationService();
  const [filter_data, setFilter_data] = useState<FilterDataProp>({
    state_id: "",
    local_government_id: "",
    search_text: "",
    state: [],
    lga: [],
    selected_lga: "",
    selected_state: "",
    reps_name: "",
    reps_id: "",
  });
  const [reps_modal, setReps_modal] = useState(false);

  const toggle_reps = () => setReps_modal(!reps_modal);
  const fetch_states = async () => {
    try {
      const states_data = await getStates();
      setFilter_data((prev) => ({ ...prev, state: states_data }));
    } finally {
    }
  };

  const fetch_lga = async () => {
    try {
      const lgaData = await getLgaById(filter_data?.state_id);
      setFilter_data((prev) => ({ ...prev, lga: lgaData }));
    } finally {
    }
  };

  useEffect(() => {
    if (filter_data?.state.length === 0) {
      fetch_states();
    }
    if (filter_data?.state_id != "") {
      fetch_lga();
    }
  }, [filter_data?.state_id]);

  const handle_state = (id: number) => {
    const state_selected = filter_data?.state?.find(
      (state) => state.value === id
    );
    if (typeof state_selected?.label === "string") {
      setFilter_data((prev) => ({
        ...prev,
        state_id: id.toString(),
        selected_state: state_selected?.label,
      }));
    }
  };
  const handle_lga = (id: number) => {
    const lga_selected = filter_data?.lga?.find((lga) => lga.value === id);
    if (typeof lga_selected?.label === "string") {
      setFilter_data((prev) => ({
        ...prev,
        local_government_id: id.toString(),
        selected_lga: lga_selected?.label,
      }));
    }
  };

  // handle reps
  const handle_value = (value: { id: number; name: string }) => {
    setFilter_data((prev) => ({
      ...prev,
      reps_id: value?.id.toString(),
      reps_name: value?.name.toString(),
    }));
  };

  const handle_submit = () => {
    if (!filter_data.selected_state) {
      showNotification("Please select a state", "info");
      return;
    }
    if (!filter_data.selected_lga) {
      showNotification("Please select a local government", "info");
      return;
    }

    navigate(`/search`, {
      state: {
        search: text || filter_data?.search_text,
        state: filter_data?.selected_state,
        lga: filter_data?.local_government_id,
        lga_name: filter_data?.selected_lga,
        reps_id: filter_data?.reps_id,
        reps_name: filter_data?.reps_name,
        resp: "true",
      },
    });
    handle_modal();
  };
  return (
    <>
      <ModalContainer
        size="sm"
        openModal={open}
        handleModal={() => {}}
        sx={{}}
        fullWidth={true}
      >
        <Box sx={{ background: "#fff", py: 3, px: 4, borderRadius: "16px" }}>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Stack direction={"row"} alignItems={"center"} spacing={2}>
              <FilterListIcon color="primary" />
              <Typography>Search Representative</Typography>
            </Stack>
            <Button sx={{ minWidth: 10 }} onClick={handle_modal}>
              <CloseDrawerIcon />
            </Button>
          </Stack>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Stack
              sx={{ my: 2 }}
              direction={"row"}
              alignItems={"center"}
              spacing={1}
            >
              <InputLabel sx={{ ...labelSty, width: 180 }}>State:</InputLabel>
              <SelectInput
                value={filter_data.state_id}
                onChange={(e) => handle_state(e.target.value)}
                options={filter_data?.state}
              />
            </Stack>
            <Stack
              sx={{ my: 2 }}
              direction={"row"}
              alignItems={"center"}
              spacing={1}
            >
              <InputLabel sx={{ ...labelSty, width: 180 }}>
                Local government
              </InputLabel>
              <SelectInput
                value={filter_data.local_government_id}
                onChange={(e) => handle_lga(e.target.value)}
                options={filter_data?.lga}
              />
            </Stack>
          </Box>
          <Stack
            direction={"row"}
            justifyContent={"flex-end"}
            sx={{
              my: 2,
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handle_submit}
              sx={{
                borderRadius: "10px",
                width: 220,
                boxShadow: "none",

                height: "3rem",
              }}
            >
              Search
            </Button>
          </Stack>
        </Box>
      </ModalContainer>
      <SearchRepsModal
        open={reps_modal}
        filter_data={filter_data}
        modal_handler={toggle_reps}
        get_reps_info={handle_value}
      />
    </>
  );
};
